import { Outlet } from "react-router-dom";

const ModalExamplePage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ModalExamplePage;
